<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-ops-management`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M42 4a2 2 0 012 2v30a2 2 0 01-2 2H26v3h9a1 1 0 011 1v2a1 1 0 01-1 1H13a1 1 0 01-1-1v-2a1 1 0 011-1h9v-3H6a2 2 0 01-2-2V6a2 2 0 012-2h36zm-2 4H8v26h32V8zm-15.3 3.801L21.9 9l-2.829 2.828 1.442 1.442-.425 3.818-3.818.425-1.442-1.442L12 18.9l2.801 2.802 6.362-.708 2.28 2.28-.705 6.364 2.801 2.801 2.828-2.828-1.441-1.441.424-3.819 3.819-.424 1.441 1.441 2.828-2.828-2.8-2.801-6.366.707-2.279-2.279.708-6.365z"/></svg>
</template>
<script>

export default {
  name: 'IconOpsManagement',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
